<template>
  
  <div style="background-color: #FFFFFF ;width: 100%;display: flex;justify-content: center">
    <span style="text-align: center;">
      <img :src="require('@/assets/app.png')" style="width: 100px;height: 100px;" alt=""><br/>
      <a href="https://easylink.cc/466548">app下载体验</a>
    </span>
    <div id ="ChinaEchart" style="width: 1000px;height: 1000px;"></div>
    <a-button type="primary" v-if="now_province!='china'" size="small" @click="back">返回中国</a-button>
  </div>
</template>



<script>

import * as echarts from 'echarts'
import {ChinaEcharts} from "@/views/Echarts/echart_home";
import {Get_Json} from "@/views/Echarts/json";
import {get_home} from "@/api/home";


export default {
  data() {
    return {
      ChinaEchart:null,
      ChinaEchart_data:[],
      ChinaEchart_Option:{},
      now_province:'china'
    }
  },
  methods: {
    get_home(){

    },
    back(){
      this.now_province='china';
      this.init_map();
    },
      async get_map_data() {
    try {
      const res = await get_home(this.now_province);
      console.log('HOME:'+res.code);
      this.ChinaEchart_data = res.cityList;
      console.log(this.ChinaEchart_data);
    } catch (error) {
      console.error('Error fetching map data:', error);
    }
  },
    async init_map(){
      await this.get_map_data();
      console.log(this.ChinaEchart_data);
      this.ChinaEchart_Option = ChinaEcharts(this.ChinaEchart_data);
      this.ChinaEchart = echarts.init(document.getElementById('ChinaEchart'));
      this.ChinaEchart.showLoading();
      var usaJson = Get_Json(this.now_province);
      this.ChinaEchart.hideLoading();
      echarts.registerMap('CHINA', usaJson, {
        Alaska: {
          left: -131,
          top: 25,
          width: 15
        },
        Hawaii: {
          left: -110,
          top: 28,
          width: 5
        },
        'Puerto Rico': {
          left: -76,
          top: 26,
          width: 2
        }
      });
      this.ChinaEchart.setOption(this.ChinaEchart_Option);


      var that = this;
      this.ChinaEchart.on("click", function (params) {
        that.now_province = params.name;
        that.init_map();
      });
    },
    initialize(){
      this.init_map();
    },
    navigateTo(pathName) {
      this.$router.push({ path: pathName });
    },
  },
  mounted() {
    this.initialize();
  },
};
</script>

<style scoped></style>
